/* eslint-disable */
import React, { useEffect, useState } from "react";
import Select from "react-select";

/*import url and gateway methods */
import { getData, putData } from "utils/Gateway";
import * as url from "helper/UrlHelper";

//import images
import { assetImages } from "constants";

//import current date
import { getCurrentDateInString } from "helper/getcurrentdatestring";

//import membership options from json
import EventMembershipStatusOption from "data/Prod/MembershipStatus.json";
import { useTranslation } from "react-i18next";
import { reactSelectStyle } from "Config/Config";

const MemberDetailsPopup = ({
  roleList,
  memberId,
  setMemberId,
  afterPopupClose,
  projectId,
  setShowAlert,
  setAlertMessage,
  setMessageType,
}) => {
  const token = localStorage.getItem("token");
  const { t } = useTranslation(); //for translation
  const [projectMemeberId, setProjectMemeberId] = useState(null);
  const [memberImage, setmemberImage] = useState("");
  const [memberName, setmemberName] = useState("");
  const [memberEmail, setmemberEmail] = useState("");
  const [memberRole, setmemberRole] = useState("");
  const [roleValue, setRoleValue] = useState(null);
  const [roleData, setRoleData] = useState(null);
  const [memberStatusValue, setmemberStatusValue] = useState(null);
  const [memberStatusData, setmemberStatusData] = useState(null);
  const [projectMemberStatus, setProjectMemberStatus] = useState("0");

  const [isUpdating, setisUpdating] = useState(false);

  //function for get details of event member
  const getMemberDetails = async () => {
    try {
      let requestUrl =
        url.API_BASE_URL +
        url.API_GET_PROJECT_MEMBER_DETAILS +
        `/${memberId}?token=${token}`;

      const response = await getData(requestUrl);
      console.log(response);

      if (response.status) {
        setProjectMemeberId(response.data.projectmemberid);
        setmemberImage(response.data.image);
        setmemberName(response.data.name);
        setmemberEmail(response.data.email);
        setmemberRole(response.data.rolestring);
        roleSelectionHandler(response.data.roledata);
        EventMembershipStatusOption.map((membership) => {
          if (response.data.moderatorstatus == membership.value) {
            memberShipStatusSelectionHandler(membership);
          }
        });
        setProjectMemberStatus(response.data.memberstatus);
      } else {
        setMessageType("error");
        setAlertMessage(response.message);
        setShowAlert(true);
      }
    } catch (error) {
      setMessageType("error");
      setAlertMessage(error.message);
      setShowAlert(true);
    }
  };

  //function for select role
  const roleSelectionHandler = (val) => {
    if (val) {
      setRoleValue(val);
      setRoleData(val.value);
    } else {
      resetRoleSelect();
    }
  };

  //function for select memebership status
  const memberShipStatusSelectionHandler = (val) => {
    if (val) {
      setmemberStatusValue(val);
      setmemberStatusData(val.value);
    } else {
      resetMemberStatus();
    }
  };

  //function for reset role select
  const resetRoleSelect = () => {
    setRoleValue(null);
    setRoleData(null);
  };

  //function for reset memberstatus select
  const resetMemberStatus = () => {
    setmemberStatusValue(null);
    setmemberStatusData(null);
  };

  //function for update membership
  const updateMemberHandler = async () => {
    setisUpdating(true);
    try {
      let memberData = {
        role: roleData,
        moderatorstatus: memberStatusData,
        joiningdate: memberStatusData == "1" ? getCurrentDateInString() : "",
      };

      // console.log(memberData);

      let requestUrl =
        url.API_BASE_URL +
        url.API_UPDATE_PROJECT_MEMBER +
        `/${memberId}?token=${token}&project=${projectId}&projectmemberid=${projectMemeberId}&projectmemberstatus=${projectMemberStatus}`;

      const response = await putData(requestUrl, memberData);

      setisUpdating(false);
      // console.log(response);

      if (response.status) {
        setMessageType("success");

        //hide member modal
        let offCanvasPopup = document.querySelector("#offcanvasMemberDetails");
        let offCanvas = bootstrap.Offcanvas.getInstance(offCanvasPopup);
        offCanvas.hide();

        closePopupHandler();
        afterPopupClose();
      } else {
        setMessageType("error");
      }

      setAlertMessage(response.message);
    } catch (error) {
      setMessageType("error");
      setAlertMessage(error.message);
    }

    setShowAlert(true);
  };

  //function for after close popup
  const closePopupHandler = () => {
    setMemberId(null);
    setProjectMemeberId(null);
    setmemberImage("");
    setmemberName("");
    setmemberEmail("");
    setmemberRole("");
    resetRoleSelect();
    resetMemberStatus();
  };

  useEffect(() => {
    if (memberId) {
      getMemberDetails();
    }
  }, [memberId]);

  return (
    <div
      className="offcanvas md offcanvas-end bg-white border-0 shadow-lg"
      tabIndex="-1"
      id="offcanvasMemberDetails"
      aria-labelledby="offcanvasMemberDetailsLabel"
    >
      {/* Header design similar to SaveFeedbackRulePopup */}
      <div className="offcanvas-header bg-primary text-white p-4 pe-5 pb-3 border-bottom border-gray-300">
        <div className="d-flex align-items-center gap-3">
          <div className="icon-wrapper p-3 bg-white rounded-circle d-flex align-items-center justify-content-center">
            <span className="material-symbols-outlined text-primary fs-5 icon-md">
              person
            </span>{" "}
            {/* Using 'person' icon */}
          </div>
          <div>
            <h3
              className="offcanvas-title fw-bold text-white mb-0"
              id="offcanvasMemberDetailsLabel"
            >
              {t("Member Details")}
            </h3>
            <p className="text-white fs-sm mb-0">
              {t("View and manage member information")}
            </p>
          </div>
        </div>
        <button
          type="button"
          className="btn-close p-1 bg-gray-200 rounded-circle shadow-sm border-0"
          data-bs-dismiss="offcanvas"
          aria-label="Close"
          onClick={closePopupHandler}
        ></button>
      </div>
      <div className="offcanvas-body p-4">
        <div className="p-3 p-md-4 border border-gray-300 rounded-10 shadow-sm bg-white">
          {/* Member Profile Card */}
          <div className="member-profile-section">
            <div className="profile-card bg-white rounded-3 p-4 shadow-sm border border-gray-300">
              <div className="d-flex align-items-center gap-3">
                <div className="avatar-wrapper position-relative">
                  <div
                    className="avatar rounded-circle overflow-hidden border border-white shadow-sm"
                    style={{ width: "56px", height: "56px" }}
                  >
                    <img
                      src={
                        memberImage == ""
                          ? assetImages.defaultUser
                          : url.SERVER_URL + memberImage
                      }
                      alt="user"
                      className="w-100 h-100 object-fit-cover"
                    />
                  </div>
                </div>
                <div className="member-info flex-grow-1">
                  <h5 className="member-name fw-bold text-dark mb-1">
                    {memberName}
                  </h5>
                  <div className="d-flex align-items-center gap-2 text-gray-600">
                    <span className="material-symbols-outlined icon-sm">
                      email
                    </span>
                    <span className="fs-sm">{memberEmail}</span>
                  </div>
                  <div className="member-role mt-2">
                    <span className="badge bg-primary bg-opacity-10 text-primary px-2 py-1 rounded-pill fs-xs fw-semibold">
                      {memberRole}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Member Information Section */}
          <div className="member-info-section py-4">
            <div className="info-header d-flex align-items-center gap-2 mb-3">
              <span className="material-symbols-outlined text-primary icon-md">
                info
              </span>
              <h6 className="mb-0 fw-semibold text-dark">
                {t("Member Information")}
              </h6>
            </div>
            <div className="info-card bg-white rounded-3 border border-gray-300 shadow-sm">
              <div className="info-item d-flex align-items-center justify-content-between p-3 border-bottom border-gray-200">
                <div className="d-flex align-items-center gap-2">
                  <span className="material-symbols-outlined text-gray-500 icon-sm">
                    badge
                  </span>
                  <span className="fs-sm text-gray-600">
                    {t("Current Role")}
                  </span>
                </div>
                <span className="fs-sm fw-semibold text-dark">
                  {memberRole}
                </span>
              </div>
              {/* Additional info items can be added here */}
            </div>
          </div>

          {/* Edit Member Form Section */}
          <div className="edit-form-section py-4">
            <div className="form-header d-flex align-items-center gap-2 mb-4">
              <span className="material-symbols-outlined text-primary icon-md">
                edit
              </span>
              <h6 className="mb-0 fw-semibold text-dark">
                {t("Edit Member Details")}
              </h6>
            </div>

            <form
              onSubmit={(e) => e.preventDefault()}
              className="d-flex flex-column h-100"
            >
              <div className="form-card bg-white rounded-3 border border-gray-300 shadow-sm p-4 mb-4">
                <div className="row g-3">
                  {/* Role Selection */}
                  <div className="col-12">
                    <div className="form-group">
                      <label
                        htmlFor="role"
                        className="form-label d-flex align-items-center gap-2 fs-sm fw-semibold text-dark mb-2"
                      >
                        <span className="material-symbols-outlined icon-sm text-primary">
                          person_pin
                        </span>
                        {t("Role")}
                      </label>
                      <Select
                        isClearable
                        className="w-100"
                        placeholder={t("Select role")}
                        options={roleList}
                        value={roleValue}
                        onChange={(val) => roleSelectionHandler(val)}
                        styles={reactSelectStyle("3px", "6px", true, false)}
                      />
                    </div>
                  </div>

                  {/* Status Selection */}
                  <div className="col-12">
                    <div className="form-group">
                      <label
                        htmlFor="status"
                        className="form-label d-flex align-items-center gap-2 fs-sm fw-semibold text-dark mb-2"
                      >
                        <span className="material-symbols-outlined icon-sm text-primary">
                          toggle_on
                        </span>
                        {t("Status")}
                      </label>
                      <Select
                        isClearable
                        className="w-100"
                        placeholder={t("Select status")}
                        options={EventMembershipStatusOption}
                        value={memberStatusValue}
                        onChange={(val) =>
                          memberShipStatusSelectionHandler(val)
                        }
                        styles={reactSelectStyle("3px", "6px", true, false)}
                      />
                    </div>
                  </div>
                </div>
              </div>
              {/* Action Buttons */}
              <div className="action-section bg-white rounded-3 border border-gray-300 shadow-sm p-4">
                <div className="d-flex justify-content-between align-items-center">
                  <div className="action-info">
                    <h6 className="mb-1 fw-semibold text-dark">
                      {t("Save Changes")}
                    </h6>
                    <p className="mb-0 fs-sm text-gray-500">
                      {t("Update member role and status")}
                    </p>
                  </div>
                  <button
                    type="button"
                    className="btn btn-primary d-flex align-items-center gap-2 px-4 py-2"
                    onClick={updateMemberHandler}
                    disabled={isUpdating}
                    style={{
                      cursor: isUpdating ? "not-allowed" : "pointer",
                      minWidth: "120px",
                    }}
                  >
                    {isUpdating ? (
                      <>
                        <span
                          className="spinner-border spinner-border-sm"
                          role="status"
                          aria-hidden="true"
                        ></span>
                        <span>{t("Saving...")}</span>
                      </>
                    ) : (
                      <>
                        <span className="material-symbols-outlined icon-sm">
                          save
                        </span>
                        <span className="fw-semibold">{t("Save")}</span>
                      </>
                    )}
                  </button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MemberDetailsPopup;
